import { render, staticRenderFns } from "./ImgCutter.vue?vue&type=template&id=07dbd842&scoped=true"
import script from "./ImgCutter.vue?vue&type=script&lang=js"
export * from "./ImgCutter.vue?vue&type=script&lang=js"
import style0 from "./ImgCutter.vue?vue&type=style&index=0&id=07dbd842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dbd842",
  null
  
)

export default component.exports